import { DefaultState } from './default-state.type';

export const defaultState: DefaultState = {
};
